import React from "react"
import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { Button, Form, Input, Select } from "antd"

// Components
import showSecondarySidebar from "../../../../layout/MainLayout/helpers/showSecondarySidebar"
import SimpleColorPicker from "../../../../components/SimpleColorPicker"
import Page from "../../../../components/Decoration/Page"

// Services Library
import { REDUX } from "../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

// Style
import styles from '../index.module.css'

const VehicleGroupCUForm = ({
    data = {},
}) => {

    const title = data?.title || 'Create'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const uid = useSelector(REDUX.reduxStoreWrapper('user.uid'))
    const userList = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))
    const vehicleStatics = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))

    const userListOptions = Object.values(userList).map(ul => ({
        label: ul.name,
        value: ul.uid
    }))

    const vehicleOptions = Object.values(vehicleStatics).map(v => ({
        label: v.plate,
        value: v.vid
    }))

    const onFinish = (e) => {

        switch(title) {
            case 'Create': {
                dispatch(REDUX_ACTIONS.v3_vehicleGroups.create_vehicle_group_request({
                    ...e,
                    uid,
                    status: 1
                }, (vhcgid) => {
                    // navigate(data.route || `/management/vehicleGroup`)
                    navigate(-1)
                    dispatch(REDUX_ACTIONS.v3_vehicleGroups.batch_get_vehicle_groups_request([vhcgid], uid))
                }))

                break;
            }
            case 'Edit': {
                dispatch(REDUX_ACTIONS.v3_vehicleGroups.update_vehicle_group_request({
                    ...e,
                    uid,
                    status: data.status || 1,
                    vhcgid: data.vhcgid
                }, (vhcgid) => {
                    // navigate(data.route || `/management/vehicleGroup`)
                    navigate(-1)
                    dispatch(REDUX_ACTIONS.v3_vehicleGroups.batch_get_vehicle_groups_request([vhcgid], uid))
                }))

                break;
            }
        }
    }
    
    return (
        <div className="page-container">
            <Page title={`${title} Vehicle Group`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 5 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        ...data,
                        vids: data?.vehicles,
                        imei: data?.dvid?.split('#')[1],
                        company: uid
                    }}
                >
                    <Form.Item
                        label="Company Name"
                        name="company"
                        rules={[
                            {
                                required: true,
                                message: 'Please input company name!',
                            },
                        ]}
                        >
                            <Select size="large" options={userListOptions} disabled />
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Group Name"
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input vehicle group name!',
                                },
                            ]}
                        >
                            <Input size="large "/>
                        </Form.Item>
                        <Form.Item
                            label="Vehicle Group Color"
                            name="color"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input vehicle group color!',
                                },
                            ]}
                        >
                            <SimpleColorPicker />
                        </Form.Item>
                        <Form.Item
                            label="Assign Vehicles"
                            name="vids"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input vehicles!',
                                },
                            ]}
                        >
                            <Select mode='multiple' size="large" options={vehicleOptions} />
                        </Form.Item>

                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">{title === 'Create' ? 'Add' : 'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedVehicleGroupCUForm = React.memo(VehicleGroupCUForm);

export default showSecondarySidebar(false)(MemoizedVehicleGroupCUForm);